import DteCrmDashboard from "./DteCrmDashboard";

export default function Dashboard() {
  return <DteCrmDashboard />;
}
